import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coursessidebar',
  templateUrl: './coursessidebar.component.html',
  styleUrls: ['./coursessidebar.component.css']
})
export class CoursessidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
